import { css } from "@emotion/react"
import styled from "@emotion/styled"
import { radiusLg, radiusMd, spacingStaticSm, spacingStaticXs } from "@porsche-design-system/components-react/emotion"
import { shouldForwardProp } from "src/common/shouldForwardProp"
import { SkeletonComponent } from "./SkeletonComponent"
import { SkeletonText } from "./SkeletonText"

interface SkeletonCheckboxProps {
	className?: string
	compact?: boolean
	withLabel?: boolean
}

export const SkeletonCheckbox = ({ className, compact, withLabel = true }: SkeletonCheckboxProps) => (
	<Wrapper className={className} $compact={compact}>
		<Box />
		{withLabel && <StyledSkeletonText size={compact ? "xs" : undefined} />}
	</Wrapper>
)

const Wrapper = styled("div", { shouldForwardProp })<{ $compact?: boolean }>`
	display: flex;
	align-items: center;
	gap: ${spacingStaticSm};
	
	${({ $compact }) =>
		$compact &&
		css`
		gap: ${spacingStaticXs};
		${Box} {
			margin: 3px 0;
			height: 18px;
			min-width: 18px;
			border-radius: ${radiusMd};
		}
	`}
`

const Box = styled(SkeletonComponent)`
	height: 28px;
	min-width: 28px;
	border-radius: ${radiusLg};
`

const StyledSkeletonText = styled(SkeletonText)`
	width: 200px;
`
